import React from 'react';

import IcomoonReact from 'icomoon-react';
import iconSet from 'Assets/selection.json';

const Icon = (props) => {
  const { color, size = '100%', icon, className = '', disabled  } = props;

  // Add error handling to prevent rendering issues
  if (!icon || !iconSet) {
    console.error('Missing icon or iconSet in Icon component');
    return null; // Return null instead of an invalid element
  }

  try {
    return (
      <IcomoonReact
        className={className}
        iconSet={iconSet}
        color={disabled ? '#C6CDD3' : color}
        size={size}
        icon={icon}
      />
    );
  } catch (error) {
    console.error('Error rendering icon:', error);
    return <span className={`icon-error ${className}`}>⚠️</span>;
  }
};

export default Icon;
